import { Component, Input, SimpleChanges } from '@angular/core';

import { I18nService } from '@recruitee/i18n';

import { IconName } from '../../../icons-container/icons.type';
import { IconColor } from '../../icon/icon.component';

export type segmentedButtonType<T> = {
  isActive: boolean;
  isAvailable: boolean;
  value: T;
  label?: string | undefined;
  counter?: number | undefined | null;
  iconName?: IconName | undefined;
};

export type LanguageSwitcherItem = {
  code: string;
  name: string;
  primary: boolean;
  translationFieldsCount: number;
};

@Component({
  selector: 'rt-segmented-control-button',
  templateUrl: './segmented-control-button.component.html',
  styleUrls: ['./segmented-control-button.component.less'],
  host: {
    '[class.active-btn]': 'isActive',
    '[class.disabled]': 'isDisabled',
    '[class.context-alt]': 'context === "alt"',
    '[class.full-width]': 'fullwidth',
  },
})
export class SegmentedControlButtonComponent {
  @Input() public type: 'view-switcher' | 'multilang-switcher';
  @Input() public context: 'default' | 'alt';
  @Input() public fullwidth: boolean;
  @Input() public isActive: boolean;
  @Input() public isAvailable: boolean;
  @Input() public label: string | undefined;
  @Input() public counter: number | undefined | null;
  @Input() public iconName: IconName | undefined;
  @Input() public isDisabled: boolean | undefined;
  @Input() public language: LanguageSwitcherItem;
  @Input() public primaryLanguageLabel = 'app.common.default';
  @Input() public fieldsCount: number;
  @Input() public loadingLanguageCode: string | null = null;

  public iconColor: IconColor;
  public IconColor = IconColor;

  constructor(private i18n: I18nService) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.isActive) {
      this.iconColor = this.isActive ? IconColor.Primary : IconColor.Default;
    }
    if (changes.isDisabled) {
      if (this.isDisabled) {
        this.iconColor = IconColor.Light;
      }
    }
  }

  public getTranslationProgress(translationFieldsCount: number): number {
    return this.fieldsCount ? (translationFieldsCount / this.fieldsCount) * 100 : 0;
  }

  public getTooltipMessage(langTermsCount: number): string {
    return `${langTermsCount} / ${this.fieldsCount} ${this.i18n.translate(
      'app.languages.fields_translated',
    )}`;
  }
}
